<form [formGroup]="repairModeFilterForm">
  <div class="form-content">
    <div class="pure-g">
      <div class="pure-u-md-12-24 p-b-12 p-r-16">
        <mc-multi-select
          label="Repair Mode - Description"
          fit="medium"
          placeholder="Select an option"
          ngDefaultControl
          formControlName="repairModeCodeList">
          @if (isLoadingModes) {
            <mc-option value="" disabled>Loading...</mc-option>
          }
          @for (item of modeDescriptionList; track item.code) {
            <mc-option [attr.data-cy]="item.code" [value]="item.code + ' - ' + item.description">
              {{ item.code }} - {{ item.description }}
            </mc-option>
          }
        </mc-multi-select>
      </div>
      <div class="pure-u-md-12-24 p-b-12 p-r-16">
        <mc-radio-group
          ngDefaultControl
          name="activeStatusesList"
          legend="Active"
          fit="medium"
          orientation="horizontal"
          formControlName="activeStatusesList">
          <mc-radio name="activeStatusesList" value="true" label="Yes"></mc-radio>
          <mc-radio name="activeStatusesList" value="false" label="No"></mc-radio>
        </mc-radio-group>
      </div>
    </div>
  </div>
</form>
